import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_container = _resolveComponent("v-container");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Vielen Dank für deine Buchung", -1)),
        _createVNode(_component_v_container, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" Deine Buchung ist bei uns eingegangen. In Kürze erhälst du eine Email mit der Rechnung und allen weiteren wichtigen Informationen. Wir wünschen jetzt schon viel Spaß! ")
            ])),
            _: 1
        })
    ], 64));
}
